import React, { useEffect, useState } from 'react';
import { useApolloClient, useLazyQuery } from '@apollo/react-hooks';
import { GET_INVITE_CODE_AGENT_TAB } from './queries';
import { useHistory } from 'react-router-dom';
import UIIconButton from '../../../../../../components/UI/UIIconButton';
import UIModal from '../../../../../../components/UI/UIModal';
import UIOverlayCard from '../../../../../../components/UI/UIOverlayCard';
import UIUserSearch from '../../../../../../components/UI/UIUserSearch/UIUserSearch';
import { USER_ROLE_AFFILIATE } from '../../../../../../utils/Config/Constants';
import Queries from '../../../../../../utils/API/Queries';
import { toast } from 'react-toastify';
import * as strings from './strings';
import { UI_ICON_BUTTON_CANCEL_TYPE, UI_ICON_BUTTON_FILL_TYPE } from '../../../../../../components/UI/UIIconButton/config';

export default function InviteCodeInfoTab({ inviteId }: InviteCodeSalespersonTabProps) {
	const history = useHistory();
	const client = useApolloClient();
	const [inviteCode, setInviteCode] = useState<InviteCodeType>();
	const [salesPersonToAdd, setSalesPersonToAdd] = useState<UserType>();
	const [isSavingSalesPerson, setIsSavingSalesPerson] = useState<boolean>(false);
	const [selectingSalesperson, setSelectingSalesperson] = useState<boolean>(false);

	const [getInviteCode, { data: inviteCodeData }] = useLazyQuery(GET_INVITE_CODE_AGENT_TAB, {
		variables: { q: { id: { op_eq: inviteId } } }
	});

	useEffect(() => {
		(async () => {
			await getInviteCode();
		})();
	}, []);

	useEffect(() => {
		(async () => {
			if (inviteCodeData) {
				setInviteCode(inviteCodeData.forms[0]);
			}
		})();
	}, [inviteCodeData]);

	if (!inviteCode) return null;

	const renderSalespersonSelect = () => {
		return (
			<UIIconButton
				dark
				className='chooseBtn'
				text={strings.chooseSalespersonButton}
				type={UI_ICON_BUTTON_FILL_TYPE}
				onClick={() => setSelectingSalesperson(true)}
			/>
		);
	};

	const addSalesPerson = async () => {
		if (!isSavingSalesPerson && salesPersonToAdd) {
			setIsSavingSalesPerson(true);
			const response = await client
				.mutate({
					mutation: Queries.UPDATE_FORM,
					variables: { id: inviteCode.id, salesman: salesPersonToAdd.id }
				})
				.catch((error) => {
					toast.error(error.message);
				});
			const { updateForm } = response['data'];
			if (!updateForm) {
				toast.error(strings.errorPickingSalesperson);
				return;
			}
			await getInviteCode();
			setSelectingSalesperson(false);
			setIsSavingSalesPerson(false);
			toast.success(strings.successUpdatingSalesperson);
		}
	};

	const renderChooseSalesperson = () => {
		const hideModal = () => setSelectingSalesperson(false);
		return (
			<UIModal condition={selectingSalesperson}>
				<UIOverlayCard hideModal={hideModal} title={strings.chooseSalespersonTitle} description={strings.chooseSalespersonDescription}>
					<UIUserSearch
						emptySetText={strings.chooseSalespersonEmptySet}
						role={USER_ROLE_AFFILIATE}
						placeholder={strings.chooseSalespersonPlaceholder}
						selectedUser={salesPersonToAdd}
						onSelectUser={(salesPersonToAdd) => setSalesPersonToAdd(salesPersonToAdd)}
					/>
					<div className='uiCard__buttons' style={{ marginTop: 16 }}>
						<UIIconButton
							dark
							text={strings.addButton}
							type={UI_ICON_BUTTON_FILL_TYPE}
							isDisabled={!salesPersonToAdd}
							isLoading={isSavingSalesPerson}
							onClick={addSalesPerson}
						/>
						<UIIconButton dark text={strings.cancelButton} type={UI_ICON_BUTTON_CANCEL_TYPE} onClick={hideModal} />
					</div>
				</UIOverlayCard>
			</UIModal>
		);
	};

	const routeToSalesman = () => {
		if (inviteCode.salesman) {
			history.push('/salesperson/' + inviteCode.salesman.id);
		} else {
			toast.error(strings.noSalesperson);
		}
	};

	return (
		<div className='servicesUsed'>
			<p onClick={routeToSalesman}>{inviteCode.salesman ? inviteCode.salesman.name : strings.noSalesperson}</p>
			{renderSalespersonSelect()}
			{renderChooseSalesperson()}
		</div>
	);
}
